import ProxyUrl from '../../constants/ProxyUrls'
import axios from 'axios'
import _ from 'lodash'

const initState = {
  histories: [],
}

export const state = Object.assign({}, _.cloneDeep(initState))

export const mutations = {
  addHistory(state: any, history: any) {
    state.histories.push(history)
  },

  emptyHistory(state: any, histories: any) {
    state.histories = histories
  },

  setHistories(state: any, histories: any) {
    state.histories = histories
  },

  resetState(state: any) {
    Object.assign(state, _.cloneDeep(initState))
  },
}

export const getters = {
  histories(state: any) {
    return state.histories
  },
}

export const actions = {
  async findAllByPk({ commit }: any, payload: any) {
    try {
      const response = await axios.get(`${ProxyUrl.getallbphistories}`, payload)
      const result = response.data.responseData
      let histories
      if (result) {
        histories = result.filter((e: any) => e.exemplarId === payload.id)
      }
      commit('setHistories', histories)
      return histories
    } catch {
      commit('emptyHistory', [])
    }
  },

  async addHistory({ commit }: any, data: any) {
    const saveData = _.cloneDeep(data)

    const resItem = await axios.post(`${ProxyUrl.createbphistory}`, saveData)
    if (Number(resItem.data.httpStatus) === 200) {
      const history = resItem.data.responseData
      commit('addHistory', history)
      return true
    } else return false
  },

  async updateHistory({ commit }: any, data: any) {
    const saveData = _.cloneDeep(data)

    const resItem = await axios.put(`${ProxyUrl.createbphistory}`, saveData)
    if (Number(resItem.data.httpStatus) === 200) {
      return true
    } else return false
  },

  resetState({ commit }: any) {
    commit('resetState')
  },
}
